var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useFetch } from '~/ApiHooks/useFetch';
import { Initial, Loading, Success } from '~/Result';
export var useApiResults = function (createRequest, deps) {
    var lastResult = React.useRef(new Initial());
    var _a = React.useState([
        new Initial(),
        deps,
    ]), _b = _a[0], results = _b[0], resultsDeps = _b[1], setResults = _a[1];
    var cancelled = React.useRef(false);
    React.useEffect(function () { return function () {
        cancelled.current = true;
    }; }, []);
    var fetch = useFetch();
    var load = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, loading, result_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (lastResult.current.isLoading) {
                        return [2 /*return*/];
                    }
                    request = createRequest(lastResult.current.value);
                    if (!(request !== null)) return [3 /*break*/, 2];
                    loading = new Loading(null);
                    lastResult.current = loading;
                    setResults(function (_a) {
                        var results = _a[0], deps = _a[1];
                        return [new Loading(results.value), deps];
                    });
                    return [4 /*yield*/, fetch(request)];
                case 1:
                    result_1 = _a.sent();
                    if (cancelled.current || loading !== lastResult.current) {
                        return [2 /*return*/];
                    }
                    lastResult.current = result_1;
                    setResults(function (_a) {
                        var results = _a[0], deps = _a[1];
                        return [result_1.map(function (response) { var _a; return __spreadArray(__spreadArray([], ((_a = results.value) !== null && _a !== void 0 ? _a : []), true), [response], false); }), deps];
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, deps);
    var reload = React.useCallback(function (limit) { return __awaiter(void 0, void 0, Promise, function () {
        var responses, request, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    responses = [];
                    request = createRequest(null);
                    _a.label = 1;
                case 1:
                    if (!(request !== null && responses.length < limit)) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(request)];
                case 2:
                    result = _a.sent();
                    if (cancelled.current) {
                        return [2 /*return*/, new Success(responses)];
                    }
                    if (result.error !== null) {
                        return [2 /*return*/, result.map(function () { return []; })];
                    }
                    if (result.value !== null) {
                        responses.push(result.value);
                    }
                    request = result.value !== null ? createRequest(result.value) : null;
                    return [3 /*break*/, 1];
                case 3:
                    setResults(function (_a) {
                        var _b;
                        var results = _a[0], deps = _a[1];
                        return [
                            new Success(__spreadArray(__spreadArray([], responses, true), ((_b = results.value) !== null && _b !== void 0 ? _b : []).slice(responses.length), true)),
                            deps,
                        ];
                    });
                    return [2 /*return*/, new Success(responses)];
            }
        });
    }); }, deps);
    React.useEffect(function () {
        lastResult.current = new Initial();
        setResults([new Initial(), deps]);
        load();
    }, deps);
    var currentResults = React.useMemo(function () {
        return deps.length === resultsDeps.length && resultsDeps.find(function (dep, index) { return deps[index] !== dep; }) === undefined
            ? results
            : new Initial();
    }, __spreadArray(__spreadArray([results], deps, true), resultsDeps, true));
    return [currentResults, load, reload];
};
